import { render, staticRenderFns } from "./message-content.vue?vue&type=template&id=074a6e41&scoped=true&"
import script from "./message-content.vue?vue&type=script&lang=js&"
export * from "./message-content.vue?vue&type=script&lang=js&"
import style0 from "./message-content.vue?vue&type=style&index=0&id=074a6e41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a6e41",
  null
  
)

export default component.exports